import { render, staticRenderFns } from "./drawing-history.vue?vue&type=template&id=af0b1572&scoped=true&"
import script from "./drawing-history.vue?vue&type=script&lang=js&"
export * from "./drawing-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0b1572",
  null
  
)

export default component.exports